import React, { useState } from 'react';
import Spiner from '../../components/Spiner';
import accessLogic from '../../functions/logic/Access';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import '../../scss/_global.scss';

export default function ResetPasword() {
    const param = useParams();
    const [spiner, setSpiner] = useState(false)
    const [password, setPassword] = useState('')
    const [passwordConfirm, setPasswordConfirm] = useState('')
    const { enqueueSnackbar } = useSnackbar();

    const keyEnter = (event) => {
        if (event.keyCode === 13) {
            handleChangePassword()
        }
    }

    const handleChangePassword = async (event) => {
        setSpiner(true);
        if ((password !== "" & passwordConfirm !== "") && (password === passwordConfirm)) {
            const resp = await accessLogic.changePasswordLogic(password, passwordConfirm, param.token);
            enqueueSnackbar(resp.message, {
                variant: resp.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
            setPasswordConfirm('');
            setPassword('');
        } else {
            enqueueSnackbar('Debe ingresar las contraseñas y tienen que coincidir', {
                variant: 'warning',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setSpiner(false);
    }
    return (
        <>
            <Spiner opt={spiner} />
            <div className="hold-transition login-page">
                <div className="login-box">
                    <div className="login-logo">
                        <a href="../../index2.html"><b>Cambiar contraseña</b></a>
                    </div>
                    <div className="card">
                        <div className="card-body login-card-body">
                            <div className="login-box-msg">Su contraseña se actualizará</div>
                            <div className="input-group mb-3">
                                <input maxLength="30" minLength="1" value={password} onKeyDown={(e) => keyEnter(e)} onChange={({ target }) => setPassword(target.value)} type="password" className="form-control" placeholder='Ingresar su contraseña' />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className={global.LOGIN_FA_PASS} ></span>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input maxLength="30" minLength="1" value={passwordConfirm} onKeyDown={(e) => keyEnter(e)} onChange={({ target }) => setPasswordConfirm(target.value)} type="password" className="form-control" placeholder='Repita su contraseña' />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className={global.LOGIN_FA_PASS} ></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <button onClick={handleChangePassword} className="btn btn-primary btn-block">Recuperar contraseña</button>
                                </div>
                            </div>
                            <div className="social-auth-links text-center mb-3">
                            </div>
                            <div className="mb-1">
                                <a href={window.location.origin}>Regresar al login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}